import { JobSummary } from '../interfaces';
import {
  mapPriorityNameToCode,
  mapStatusNameToCode,
  mapTravelModeNameToCode,
} from './';

export default function mapJobSummaryToPayload(summary: JobSummary) {
  return {
    actual_pickup_date: summary.actualPickupDate,
    bbe_number: summary.bbeNumber,
    creation_date: summary.creationDate,
    description: summary.description,
    handoff_location: summary.handoffLocation,
    id: summary.id,
    initial_planned_pickup_date: summary.initialPlannedPickupDate,
    initial_planned_staging_date: summary.initialPlannedStagingDate,
    priority_code: mapPriorityNameToCode(summary.priorityName),
    purchase_order: summary.purchaseOrder,
    revised_pickup_date: summary.revisedPickupDate,
    revised_staging_date: summary.revisedStagingDate,
    status_code: mapStatusNameToCode(summary.statusName),
    total_shipments: summary.totalShipments,
    total_weight: summary.totalWeight,
    travel_mode_code: mapTravelModeNameToCode(summary.travelModeName),
    vendor: summary.vendor,
  };
}
